import { render, staticRenderFns } from "./_request_new_version.vue?vue&type=template&id=16841735&scoped=true&"
import script from "./_request_new_version.vue?vue&type=script&lang=js&"
export * from "./_request_new_version.vue?vue&type=script&lang=js&"
import style0 from "./_request_new_version.vue?vue&type=style&index=0&id=16841735&lang=sass&scoped=true&"
import style1 from "./_request_new_version.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16841735",
  null
  
)

export default component.exports